import { observer } from "mobx-react-lite";
import { Tree, Button, Modal } from "antd";
import type { DataNode, TreeProps } from "antd/lib/tree";
import React, { useState, useEffect } from "react";
import RoleStore, { RoleInfo } from "../../../../stores/Admin/RoleStore";

export interface RoleBindAppDialogProps {
  visible: boolean;
  close: () => void;
  roleInfo: {
    id: number;
    name: string;
    //  code?: string;
    des?: string;
  };
}
const RoleBindAppDialog: React.FC<RoleBindAppDialogProps> = (props) => {
  const { appList, appListSelected } = RoleStore;
  const [checked, setChecked] = useState(RoleStore.appListSelected);
  useEffect(() => {
    RoleStore.getAllApp();
    setChecked(RoleStore.appListSelected);
  }, [RoleStore.appListSelected]);
  const submit = () => {
    const add: (undefined | string)[] = checked
      .map((item: any) => RoleStore.appListMap.get(item))
      .filter((item: string | undefined) => item != undefined);
    const del: string[] = [];
    RoleStore.appListMap.forEach((value, key) => {
      add instanceof Array && !add.includes(value) && del.push(value);
    });
    RoleStore.batchBindApp({
      roleId: props.roleInfo.id,
      addKey: add,
      delKey: del,
    });
    props.close();
  };
  const onCheck: TreeProps["onCheck"] = (checkedKeys: any, info: any) => {
    setChecked(checkedKeys);
    RoleStore.setAppListSelected(checkedKeys);
  };
  return (
    <Modal
      title="应用绑定"
      bodyStyle={{ height: "700px" }}
      visible={props.visible}
      onCancel={() => {
        props.close();
      }}
      cancelText={"取消"}
      okText={"修改"}
      onOk={submit}
    >
      <Tree
        treeData={appList}
        checkable
        height={600}
        defaultExpandAll={true}
        onCheck={onCheck}
        checkedKeys={[...appListSelected]}
      />
    </Modal>
  );
};

export default observer(RoleBindAppDialog);
